"use client";
import { useState } from "react";
import ICON_ARROW_UP from "@/assets/images/arrow-up.svg";

export default function MatchLeagues({ league, matches, render = () => { } }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { name, logo } = league;

  return (
    <div className="flex flex-col gap-2">
      <div
        className="flex items-center gap-1 bg-[var(--theme-bg)] rounded-lg p-2 cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {logo && <img src={logo} alt={name} width={25} height={25} />}
        <span className="text-sm font-semibold">{name}</span>

        <img
          className={`ml-auto transition-transform ${isExpanded ? "rotate-180" : ""}`}
          src={ICON_ARROW_UP}
          alt="arrow-up"
          width={24}
          height={24}
        />
      </div>

      {isExpanded && (
        <div className="flex flex-col gap-2">
          {matches.map((match) => render(match))}
        </div>
      )}
    </div>
  );
}
